/**
 * SkillDelivery Platform
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 *
 * ShubbhYatraOnlyBlocker
 *
 * One-page blocker shown to users whose /api/users/me response contains
 * features.shubbhYatraOnly === true. All SkillDelivery routes are
 * replaced with this page; a Logout button is the only interactive
 * element. Unflagged users never see this component.
 */

import React from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const ShubbhYatraOnlyBlocker = () => {
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      if (typeof logout === 'function') await logout();
    } finally {
      // Belt-and-braces — if logout doesn't navigate for some reason,
      // force the login screen so the blocker page isn't the dead-end.
      window.location.assign('/login');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)'
      }}
    >
      <div
        style={{
          maxWidth: 520,
          width: '100%',
          background: 'white',
          borderRadius: 16,
          boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
          padding: '40px 32px',
          textAlign: 'center'
        }}
      >
        <img
          src="/shubbhyatra-logo.png"
          alt="ShubbhYatra"
          style={{ height: 96, width: 'auto', display: 'block', margin: '0 auto 20px' }}
        />
        <div style={{ fontSize: 36, marginBottom: 12 }}>
          <span role="img" aria-label="airplane">✈</span>
        </div>
        <h1
          lang="hi"
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: '#0f172a',
            margin: '0 0 12px'
          }}
        >
          आपका खाता ShubbhYatra के लिए है — कृपया ऐप इस्तेमाल करें
        </h1>
        <p
          style={{
            fontSize: 15,
            lineHeight: 1.6,
            color: '#475569',
            margin: '0 0 28px'
          }}
        >
          This account is for ShubbhYatra — please use the app.
        </p>
        <button
          type="button"
          onClick={handleLogout}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 20px',
            borderRadius: 10,
            border: '1px solid #cbd5e1',
            background: '#0ea5e9',
            color: 'white',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer'
          }}
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default ShubbhYatraOnlyBlocker;
